




































































































import { Component, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import GroupedFactorImportanceChart from '@/components/chart/GroupedFactorImportanceChart.vue';
import { CHART_TYPES, CHART_TYPE_NAMES } from '@/utils/ChartTypes';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import Modelling from '@/store/modules/Modelling';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import { Viewpoint } from '@/api/model/Viewpoint';
import Scoring from '@/store/modules/Scoring';


const workspaceOptions = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const viewpointModule = getModule(Viewpoints);
const choiceModule = getModule(Choices);

@Component({
    name: 'WeightGroupedBarChart',
    components: {
        GroupedFactorImportanceChart,
        CardTitle,
    },
})
export default class WeightGroupedBarChart extends Vue {
    @Prop({ default: '', type: String })
    factorId!: string;

    private items = CHART_TYPES;
    private CHART_TYPE_NAMES = CHART_TYPE_NAMES;
    private isLoading = false;
    private tooltipShow = false;
    private open = false;
    private task: any;

    private chartData = {
        series: [],
        title: '',
        categories: [],
    };

    private cancelTask() {
        clearTimeout(this.task);
    }

    private chartDataDelay() {
        this.task = setTimeout(() => {this.getChartData() }, 800);
    }

    get barChartData() {
        return this.chartData;
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get isBarChartHorizontal() {
        return workspaceOptions.isFactorImportanceChartHorizontal;
    }

    set isBarChartHorizontal(isHorizontal: boolean) {
        workspaceOptions.setIsFactorImportanceChartHorizontal(isHorizontal);
    }

    get selectedChoices() {
        return choiceModule.unfilteredChoicesList;
    }

    get selectedViewpointIds() {
        return viewpointModule.selectedViewpointIds;
    }

    get viewpoints() {
        return viewpointModule.unfilteredViewpointsMap;
    }

    private async getChartData() {
        try {
            if (this.decisionId && this.selectedViewpointIds && this.factorId) {
                this.isLoading = true;
                const factor = this.factors[this.factorId];
                // WE SHOULD create a this.activeViewpoint 
                const res = await getModule(Scoring).getFactorImportanceChart({decisionId: this.decisionId, viewpointIds: this.selectedViewpointIds, factorIds:factor.childrenIds})  // VIEWPOINT_API.generateFactorImportanceChart(this.decisionId, this.selectedViewpointIds, factor.childrenIds);
                console.log("res", res);
                this.chartData = res;
                // this.chartData.series = [];
                // this.chartData.categories = [];
                // for (let key in res) {
                //     let item = { data: [], name: '' };
                //     item.data = res[key].data;
                //     item.name = this.viewpoints[key].name;
                //     this.chartData.series.push(item);
                // }
                // if (res[this.selectedViewpointIds[0]].categories) {
                //     console.log("categories found", res[this.selectedViewpointIds[0]].categories)
                //     res[this.selectedViewpointIds[0]].categories.forEach((e: string) => {
                //         if (e.length > 30) {
                //             this.chartData.categories.push(e.slice(0, 27) + '...');
                //         } else {
                //             this.chartData.categories.push(e);
                //         }
                //     });
                // }
            }
        } catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    }
}
